import { useQuery } from "@tanstack/react-query";
import { tenantApi } from "@/lib/api/client";
import { useAuthStore } from "@/lib/auth";
import { InvitesSection } from "@/components/colleague-invites/invites-section";
import { ColleaguesGuideProgress } from "@/components/guides/colleagues-guide-progress";
import { Card, Avatar, Badge, Text, Stack, Box, Group } from "@mantine/core";
import { SectionGuides } from "@/components/guides/section-guides";

export default function ColleaguesPage() {
  const isTenantAdmin = useAuthStore((s) => s.user?.is_tenant_admin);
  const { data, isLoading, isError } = useQuery({
    queryKey: ["accounts"],
    queryFn: () => tenantApi.getAccounts(),
  });

  if (isLoading) return <Box p="md">Loading...</Box>;

  if (isError) {
    return (
      <Box p="md">
        <Text fz="sm" c="red">Failed to load data. Please try again later.</Text>
      </Box>
    );
  }

  return (
    <Stack p="md" gap="md">
      <SectionGuides area="colleagues" />
      <Card padding="lg" withBorder>
        <Stack gap="md">
          <Text fw={600} fz="lg">Colleagues</Text>
          <Stack gap="sm">
            {data?.data.results?.map((user) => (
              <Group
                key={user.id}
                gap="sm"
                p="sm"
                wrap="nowrap"
                style={{ borderRadius: 8, border: "1px solid var(--mantine-color-default-border)" }}
              >
                <Avatar radius="xl">
                  {(user.first_name?.[0] || "").toUpperCase()}
                  {(user.last_name?.[0] || "").toUpperCase()}
                </Avatar>
                <Box miw={0} flex={1}>
                  <Text fw={500}>{user.first_name} {user.last_name}</Text>
                  <Text fz="sm" c="dimmed" truncate>{user.email}</Text>
                </Box>
                <Badge variant={user.is_tenant_admin ? "filled" : "light"}>
                  {user.is_tenant_admin ? "Admin" : user.tenant_role || "User"}
                </Badge>
              </Group>
            ))}
          </Stack>
        </Stack>
      </Card>
      {isTenantAdmin && <InvitesSection />}
      {isTenantAdmin && <ColleaguesGuideProgress />}
    </Stack>
  );
}
